export const apiBaseUrl = 'https://api.airspirit.com'
export const websocketBaseUrl = 'wss://api.airspirit.com'
